import NavMenu from '../views/pages/Shared/NavMenu.vue';
import { ExecutiveTable } from '../views/pages/ExecutiveTable';

export default [
    {
        name: 'executive-table',
        path: '/executive-table',
        components: {
            NavMenu,
            ExecutiveTable,
        },
    },
];
